"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugin = exports.isPlugin = void 0;
exports.isPlugin = Symbol.for('@inversifyjs/plugin/isPlugin');
class Plugin {
    [exports.isPlugin] = true;
    _container;
    _context;
    constructor(container, context) {
        this._container = container;
        this._context = context;
    }
}
exports.Plugin = Plugin;
//# sourceMappingURL=Plugin.js.map